import angular from 'angular';
import { downgradedModule } from '../../../ng-app/main';

import EventsPanelService from './EventsPanelService';
import EventsPanelComponent from './EventsPanelComponent';

export default angular
  .module('petroCloud.dashboard.eventsPanel', [
    'ui.bootstrap',
    downgradedModule
  ])
  .service('EventsPanelService', EventsPanelService)
  .component(EventsPanelComponent.name, EventsPanelComponent)
  .name;
